import {twMerge} from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(inputs)
}

export const classNames = (...classes) => {
  return classes.filter(Boolean).join(" ");
};